import { Check } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, Grid, Typography } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";

import { AssessmentType } from "../../../globals/types";
import { useAssessmentNavigation } from "../../../hooks/useAssessmentNavigation";
import { ShapeIcon } from "../../ShapeIcon";

interface Props {
    open: boolean;
    type: AssessmentType;
}

export const SubmittedModal: React.FC<Props> = ({ open, type }) => {
    const { hasMultipleAssessments, navigateBack, navigateToAssessments } = useAssessmentNavigation();

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            PaperProps={{
                sx: {
                    paddingTop: 3,
                },
            }}
        >
            <DialogContent sx={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                <Grid container direction="column" alignItems="center" rowSpacing={2} paddingX={2}>
                    <Grid>
                        <ShapeIcon icon={<Check />} size="large" color="success" />
                    </Grid>

                    {type === "feedback" && (
                        <>
                            <Grid>
                                <Typography variant="displaySm" fontWeight={500}>
                                    <FormattedMessage defaultMessage="Your review was submitted" />
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="textMd">
                                    <FormattedMessage defaultMessage="Your feedback has been submitted. Thank you for contributing to a better supplier evaluation process." />
                                </Typography>
                            </Grid>
                        </>
                    )}
                    {type === "internal" && (
                        <>
                            <Grid>
                                <Typography variant="displaySm" fontWeight={500}>
                                    <FormattedMessage defaultMessage="Thank you for submitting" />
                                </Typography>
                            </Grid>
                        </>
                    )}
                    {type === "external" && (
                        <>
                            <Grid>
                                <Typography variant="displaySm" fontWeight={500}>
                                    <FormattedMessage defaultMessage="Thank you for submitting" />
                                </Typography>
                            </Grid>
                            <Grid paddingBottom={3}>
                                <Typography variant="textSm">
                                    <FormattedMessage defaultMessage="You may now close this window." />
                                </Typography>
                            </Grid>
                        </>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <Grid paddingBottom={3}>
                    <Button
                        color="primary"
                        onClick={() => {
                            if (hasMultipleAssessments) {
                                navigateToAssessments();
                            } else {
                                navigateBack();
                            }
                        }}
                    >
                        {type === "feedback" ? (
                            <FormattedMessage defaultMessage="Return to overview" />
                        ) : (
                            <FormattedMessage defaultMessage="Close" />
                        )}
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};
